import React, { useState } from 'react';
import {
  InputGroup,
  Legend,
  ValidationMessage
} from '@gjensidige/builders-components';

import { inputRadioGroupOptions } from '../../Types';

interface RadioGroupProps {
  radioOptions: inputRadioGroupOptions[];
  preSelectedValue?: string;
  headerLabel?: string;
  onChange: any;
  errorText: string;
  invalid: boolean;
  wrapperClass?: string;
}

export const InputRadioGroup: React.FC<RadioGroupProps> = (
  props: RadioGroupProps
) => {
  const {
    errorText,
    preSelectedValue,
    headerLabel,
    radioOptions,
    invalid,
    wrapperClass,
    onChange
  } = props;

  const [value, setValue] = useState(preSelectedValue ? preSelectedValue : '');

  const onOptionSelect = (values: string[]) => {
    setValue(values[0]);
    onChange(values[0]);
  };
  return (
    <>
      <InputGroup
        variant="row"
        id="input-group-radio"
        name="input-group-radio"
        onChange={onOptionSelect}
        type="radio"
        value={value}
        invalid={invalid}
        className={wrapperClass}
      >
        <Legend>{headerLabel}</Legend>
        {radioOptions.map((option, index) => {
          return (
            <InputGroup.Input
              key={index}
              value={option.value}
              label={option.label}
            />
          );
        })}
      </InputGroup>
      {invalid && errorText && (
        <ValidationMessage>{errorText}</ValidationMessage>
      )}
    </>
  );
};
